import React from 'react';
import type { SwitchProps } from 'antd';

import StyledSwitch from './styled.tsx'; // TODO: BBL-403

export const BaseSwitch: React.FC<SwitchProps> = ({ value, onChange, ...props }) => (
    <StyledSwitch checked={value} onChange={onChange} {...props} />
);
